module.exports = __webpack_public_path__ + "img/f1.bd51d2a4.png";